import $ from "jquery";

$("a").each(function() {
    var a = new RegExp("/" + window.location.host + "/");

    if (!a.test(this.href)) {
        $(this).click(event => {
            event.preventDefault();
            window.open(this.href, "_blank");
        });
    }
});

$(".dropdown-toggle").click(function() {
    var location = $(this).attr("href");
    window.location.href = location;
    return false;
});

// prepare the form when the DOM is ready
// https://uhslc.soest.hawaii.edu/products/foo/ultimate-jquery-image-swap-gallery/jquery_demo_image_swap_gallery.htm
$(document).ready(function() {
    var galleryClass = ".gallery";
    $(galleryClass + " div img").hover(function() {
        var $gallery = $(this).parents(galleryClass);
        $(".main-img", $gallery).attr(
            "src",
            $(this)
                .attr("src")
                .replace("-150x150", "")
        );

        $(".captions", $gallery).html($(this).attr("data-custom-title"));
    });
    var imgSwap = [];
    $(galleryClass + " div img").each(function() {
        imgUrl = this.src.replace("-150x150", "");
        imgSwap.push(imgUrl);
    });
    $(imgSwap).preload();
});
$.fn.preload = function() {
    this.each(function() {
        $("<img/>")[0].src = this;
    });
};

// Deeplink to #
(function($) {
    var jump = function(e) {
        if (e) {
            e.preventDefault();
            var target = $(this).attr("href");
        } else {
            var target = location.hash;
        }

        $("html,body").animate(
            {
                scrollTop: $(target).offset().top
            },
            1000,
            function() {
                location.hash = target;
            }
        );
    };

    $("html, body").hide();

    $(document).ready(function() {
        //$('a[href^=#]').bind("click", jump);
        if (location.hash) {
            setTimeout(function() {
                $("html, body")
                    .scrollTop(300)
                    .show();
                jump();
            }, 0);
        } else {
            $("html, body").show();
        }
    });
})(jQuery);



// WEBPACK FOOTER //
// ./src/js/app/site.js